export const APP_VERSION = '2.4.0';
